import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { first } from 'rxjs/operators';
import { CustomerImageService } from '../../../customer/shared/customer-image.service';
import { ValidatedResponse } from '../../../shared/models/validated-response.model';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { IncidentModalComponent } from '../../incident-modal.component';
import { IncidentCustomer } from '../../models/incident-customer.model';
import { IncidentFinanceCollectionModel } from '../../models/incident-finance-collection.model';
import { IncidentTypeService } from '../../services/incident-type.service';
import { IncidentService } from '../../services/incident.service';
import { CollectionIncidentService } from '../../services/collection-incident.service';
import { IncidentDialogContext } from '../../shared/incident-dialog-context.model';
import { ProhibitionService } from '../../../prohibition/services/prohibition.service';
import { EnumDataService } from '../../services/enums.DataService';
import { toStringOrNull } from '../../shared/data-helpers';

@Component({
    templateUrl: './collections-incident-modal.html'
})
export class CollectionsIncidentModalComponent extends IncidentModalComponent<IncidentFinanceCollectionModel> {
    constructor(
        public service: CollectionIncidentService,
        public dialogRef: MatDialogRef<IncidentModalComponent<IncidentFinanceCollectionModel>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<IncidentFinanceCollectionModel>,
        public incidentService: IncidentService,
        public customerService: CustomerImageService,
        EnumDataService: EnumDataService,
        location: PlatformLocation,
        fb: UntypedFormBuilder,
        typeService: IncidentTypeService,
        modalService: MvdModalService,
        prohibitionService: ProhibitionService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);
    }

    protected onInit(form: any): void {
    }

    protected onLoadIncident(callback: (error?) => void): void {
        this.service.getIncident(this.data.incident.incidentNumberId).subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted(incident: IncidentFinanceCollectionModel, callback: (error?) => void): void {
        this.data.incident = incident;
        this.showUserInput = true;

        setTimeout(() => {
            this.incidentForm.get('interestDue').setValue(this.data.incident.interestDue);
            this.incidentForm.get('penaltyDue').setValue(this.data.incident.penaltyDue);
            this.data.incident.amountDue = this.data.incident.amountDue;
            this.data.incident.customerOutstandingBalanceId = 0;
        }, 350);

        callback();
    }

    public async addCustomer(event: any): Promise<void> {

        if (this.data.incident.customers.some(i => i.id == event.customerNumber)) {
            return;
        }

        let result: ValidatedResponse<IncidentCustomer> = await this.incidentService.getCustomer(event.customerNumber).pipe(first()).toPromise();

        if (result && result.result) {
            let customer: IncidentCustomer = result.result;
            this.data.incident.customers.push(customer);
        }
    }

    public removeCustomer(customer: IncidentCustomer): void {
        let index: number = this.data.incident.customers.findIndex(v => v.id == customer.id);
        this.data.incident.customers.splice(index, 1);
    }

    protected onSaveIncident(callback: (error?: any) => void): void {
        // Get form values
        this.data.incident.amountDue = this.incidentForm.get('amountDue').value;
        this.data.incident.interestDue = toStringOrNull(this.incidentForm.get('interestDue').value);
        this.data.incident.penaltyDue = toStringOrNull(this.incidentForm.get('penaltyDue').value);

        this.service.saveIncident(this.data.incident).subscribe(r => { }, callback, callback);
    }

    protected onDeleteIncident(callback: () => void): void {
        this.service.deleteIncident(this.data.incident.incidentNumberId).subscribe(result => { }, e => this.handleError, () => {
            this.dialogRef.close(true);
        });
    }
}
